import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  departments: [],
  branches: [],
  ios: [],
  ids: [],
  branchCount: 0,
  iosCount: 0,
  idsCount: 0,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getUserDepartments = createAsyncThunk(
  'user/departments',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: '/api/departments',
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const userDepartmentsSlice = createSlice({
  name: 'departments',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    getAllBranches: (state, { payload }) => {
      state.branches = payload.data.branch_data;
      state.branchCount = payload.data.deptTypeCount;
      state.isFetching = false;
      state.isError = false;
      state.isSuccess = true;
    },
    getAllIOS: (state, { payload }) => {
      state.ios = payload.data.io_independentOffices;
      state.iosCount = payload.data.deptTypeCount;
      state.isFetching = false;
      state.isError = false;
      state.isSuccess = true;
    },
    getAllIDS: (state, { payload }) => {
      state.ids = payload.data.id_directorates;
      state.idsCount = payload.data.deptTypeCount;
      state.isFetching = false;
      state.isError = false;
      state.isSuccess = true;
    },
    getAllUserDepartments: (state, { payload }) => {
      state.departments = payload.data;
      state.isFetching = false;
      state.isError = false;
      state.isSuccess = true;
    },
    clearStateDepartment: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getUserDepartments.fulfilled]: (state, { payload }) => {
      state.departments = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getUserDepartments.pending]: (state) => {
      state.isFetching = true;
    },
    [getUserDepartments.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { getAllUserDepartments, clearStateDepartment, getAllBranches, getAllIOS, getAllIDS } = userDepartmentsSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateDepartment());
  }
}

export const getAllBranchesAsyn = (page) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/department/Chief of Air Staff?code=b&page=' + page,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  // console.log(data.data)
  dispatch(getAllBranches(data));
};

export const getAllIOAsyn = (page) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/department/Chief of Air Staff?code=io&page=' + page,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  // console.log(data.data)
  dispatch(getAllIOS(data));
};

export const getAllIDAsyn = (page) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/department/Chief of Air Staff?code=id&page=' + page,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  // console.log(data.data)
  dispatch(getAllIDS(data));
};

export const setStatusAsyn = (dataObj) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.patch('/api/department/type/activeStatus', dataObj, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  //  console.log(data)
  //dispatch(setBranchStatus(data));
};

export const getAllUserDepartmentsAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/departments',
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  // console.log(data.data)
  dispatch(getAllUserDepartments(data));
};

export const userDepartmentSelector = (state) => state.departments;

export default userDepartmentsSlice.reducer;
